import React from 'react';
import { rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import { selectEligibleFreeTrialDays } from 'features/premium/selectors';
import useColors from 'hooks/useColors';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils';
import { TierPeriod, } from '../../entities';
import { formatMonthlyPriceFromYearly, formatWeeklyPriceFromMonthly, formatYearlyPrice, } from '../utils';
const HowFreeTrialWorksPricesView = ({ style, white, subscription, }) => {
    const colors = useColors();
    const primaryColor = white
        ? { White: true }
        : { color: colors.text.primary };
    const secondaryColor = white
        ? { White: true }
        : { Secondary: true };
    const eligibleFreeTrialDays = useAppSelector(selectEligibleFreeTrialDays);
    return (<View style={style}>
      <Text centered Text-20 {...primaryColor}>
        {eligibleFreeTrialDays}-day free trial
      </Text>
      <Spacer h={rem(4)}/>
      <View style={styles.trialPrices}>
        <Text TextThin-16 {...secondaryColor}>
          <Text Numbers-16 {...primaryColor}>
            {subscription.period === TierPeriod.yearly
            ? formatMonthlyPriceFromYearly({
                currency: subscription.currency,
                price: parseFloat(subscription.price),
            })
            : formatWeeklyPriceFromMonthly({
                currency: subscription.currency,
                price: parseFloat(subscription.price),
            })}
          </Text>
          {subscription.period === TierPeriod.yearly ? '/month' : '/week'}
        </Text>
        <Spacer.W8 />
        <Text TextThin-16 {...secondaryColor}>
          (billed{' '}
          {subscription.period === TierPeriod.yearly ? 'yearly' : 'monthly'} at{' '}
          <Text Numbers-16 {...primaryColor}>
            {subscription.period === TierPeriod.monthly
            ? formatAmount(parseFloat(subscription.price), subscription.currency)
            : formatYearlyPrice({
                currency: subscription.currency,
                period: TierPeriod.yearly,
                price: parseFloat(subscription.price),
            })}
          </Text>
          )
        </Text>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    trialPrices: {
        flexDirection: 'row',
        alignItems: 'baseline',
        justifyContent: 'center',
    },
});
export default HowFreeTrialWorksPricesView;
